// library imports
import React from 'react'
// component imports
import ContactForm from './ContactForm'
// styling
import { StyledContactPage } from '../../styles/StyledComps'

const ContactPage = () => {
  return (
    <StyledContactPage>
      <ContactForm />
    </StyledContactPage>
  )
}

export default ContactPage